/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIBillSearchResult
 */
export interface APIBillSearchResult {
    /**
     * 
     * @type {string}
     * @memberof APIBillSearchResult
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof APIBillSearchResult
     */
    score: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIBillSearchResult
     */
    amount?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIBillSearchResult
     */
    paid?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof APIBillSearchResult
     */
    dueDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIBillSearchResult
     */
    createdAt?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof APIBillSearchResult
     */
    contractId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIBillSearchResult
     */
    contractStatus?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIBillSearchResult
     */
    contractStatusDisplay?: string;
    /**
     * 
     * @type {string}
     * @memberof APIBillSearchResult
     */
    contractComment?: string;
    /**
     * 
     * @type {number}
     * @memberof APIBillSearchResult
     */
    requestId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIBillSearchResult
     */
    requestCertificate?: string;
    /**
     * 
     * @type {string}
     * @memberof APIBillSearchResult
     */
    requestContactFullName?: string;
    /**
     * 
     * @type {string}
     * @memberof APIBillSearchResult
     */
    requestContactEmail?: string;
    /**
     * 
     * @type {number}
     * @memberof APIBillSearchResult
     */
    articleCount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIBillSearchResult
     */
    articleNames?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIBillSearchResult
     */
    articleNumbers?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof APIBillSearchResult
     */
    editorCount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIBillSearchResult
     */
    editorNames?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIBillSearchResult
     */
    editorIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIBillSearchResult
     */
    editorEmails?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof APIBillSearchResult
     */
    rootAccountId?: string | null;
}

/**
 * Check if a given object implements the APIBillSearchResult interface.
 */
export function instanceOfAPIBillSearchResult(value: object): value is APIBillSearchResult {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('score' in value) || value['score'] === undefined) return false;
    return true;
}

export function APIBillSearchResultFromJSON(json: any): APIBillSearchResult {
    return APIBillSearchResultFromJSONTyped(json, false);
}

export function APIBillSearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIBillSearchResult {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'score': json['score'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'paid': json['paid'] == null ? undefined : json['paid'],
        'dueDate': json['due_date'] == null ? undefined : (new Date(json['due_date'])),
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'contractId': json['contract_id'] == null ? undefined : json['contract_id'],
        'contractStatus': json['contract_status'] == null ? undefined : json['contract_status'],
        'contractStatusDisplay': json['contract_status_display'] == null ? undefined : json['contract_status_display'],
        'contractComment': json['contract_comment'] == null ? undefined : json['contract_comment'],
        'requestId': json['request_id'] == null ? undefined : json['request_id'],
        'requestCertificate': json['request_certificate'] == null ? undefined : json['request_certificate'],
        'requestContactFullName': json['request_contact_full_name'] == null ? undefined : json['request_contact_full_name'],
        'requestContactEmail': json['request_contact_email'] == null ? undefined : json['request_contact_email'],
        'articleCount': json['article_count'] == null ? undefined : json['article_count'],
        'articleNames': json['article_names'] == null ? undefined : json['article_names'],
        'articleNumbers': json['article_numbers'] == null ? undefined : json['article_numbers'],
        'editorCount': json['editor_count'] == null ? undefined : json['editor_count'],
        'editorNames': json['editor_names'] == null ? undefined : json['editor_names'],
        'editorIds': json['editor_ids'] == null ? undefined : json['editor_ids'],
        'editorEmails': json['editor_emails'] == null ? undefined : json['editor_emails'],
        'rootAccountId': json['root_account_id'] == null ? undefined : json['root_account_id'],
    };
}

export function APIBillSearchResultToJSON(value?: APIBillSearchResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'score': value['score'],
        'amount': value['amount'],
        'paid': value['paid'],
        'due_date': value['dueDate'] == null ? undefined : ((value['dueDate'] as any).toISOString().substring(0,10)),
        'created_at': value['createdAt'] == null ? undefined : ((value['createdAt'] as any).toISOString()),
        'contract_id': value['contractId'],
        'contract_status': value['contractStatus'],
        'contract_status_display': value['contractStatusDisplay'],
        'contract_comment': value['contractComment'],
        'request_id': value['requestId'],
        'request_certificate': value['requestCertificate'],
        'request_contact_full_name': value['requestContactFullName'],
        'request_contact_email': value['requestContactEmail'],
        'article_count': value['articleCount'],
        'article_names': value['articleNames'],
        'article_numbers': value['articleNumbers'],
        'editor_count': value['editorCount'],
        'editor_names': value['editorNames'],
        'editor_ids': value['editorIds'],
        'editor_emails': value['editorEmails'],
        'root_account_id': value['rootAccountId'],
    };
}

